import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as componentTypes from "../../../constants/componentTypes";
import * as settings from "../../../constants/settings";
import * as rcc from "../../../constants/rcc";
import * as navigationActions from "../../../actions/navigationActions";
import * as rccActions from "../../../actions/rccActions";
import * as modelHelper from "../../../helpers/modelHelper";

import imgConfirm from "../../../resources/img/svgicons/confirm.svg";

import Button from "../generic/Button";
import Modal from "../generic/Modal";
import CancelButton from "../generic/CancelButton";

class ManualAdditionUnitModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedUnit: this.props.manualAdditionUnit
        };
    }

    getUnitsByDialog = () => {
        if (this.props.message === rcc.RCC_MESSAGE_FORMULA_OVERFILL_RULE_VOL) {
            return [[settings.UNIT_ML, settings.UNIT_SHOT]];
        }

        if (this.props.message === rcc.RCC_MESSAGE_FORMULA_OVERFILL_RULE_GRAV) {
            return [[settings.UNIT_G, settings.UNIT_KG]];
        }

        return [
            [settings.UNIT_ML, settings.UNIT_L, settings.UNIT_SHOT],
            [settings.UNIT_G, settings.UNIT_KG]
        ];
    };

    handleUnitChange = (event) => {
        this.setState({
            selectedUnit: event.target.value
        });
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    handleSaveClick = () => {
        let supportedUnits = this.getUnitsByDialog()[0].concat(
            this.getUnitsByDialog()[1] !== undefined ? this.getUnitsByDialog()[1] : []
        );

        if (supportedUnits.includes(this.state.selectedUnit)) {
            this.props.dispatchSetManualColorantAdditionUnitAction(this.state.selectedUnit);
        }

        this.props.dispatchCloseModalAction();
    };

    getUnitOptions = () => {
        let optionsVolumetric = [];
        let optionsGravimetric = [];
        let unit;

        if (this.getUnitsByDialog()[0] !== undefined) {
            for (unit of this.getUnitsByDialog()[0]) {
                optionsVolumetric.push(
                    <div key={unit} className="col-xs-12">
                        <label className="radio-style light-style">
                            <input
                                type="radio"
                                name="colorant-unit"
                                value={unit}
                                checked={this.state.selectedUnit === unit}
                                onChange={this.handleUnitChange}
                                className="radio"
                            />
                            <span className="checkmark" />
                            {unit === settings.UNIT_SHOT && this.props.shotsName !== "" ? this.props.shotsName : unit}
                        </label>
                    </div>
                );
            }
        }

        if (this.getUnitsByDialog()[1] !== undefined) {
            for (unit of this.getUnitsByDialog()[1]) {
                optionsGravimetric.push(
                    <div key={unit} className="col-xs-12">
                        <label className="radio-style light-style">
                            <input
                                type="radio"
                                name="colorant-unit"
                                value={unit}
                                checked={this.state.selectedUnit === unit}
                                onChange={this.handleUnitChange}
                                className="radio"
                            />
                            <span className="checkmark" />
                            {unit}
                        </label>
                    </div>
                );
            }
        }

        return (
            <React.Fragment>
                <div className="col-xs-6">{optionsVolumetric}</div>
                <div className="col-xs-6">{optionsGravimetric}</div>
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="modal.changeColorantUnit" />)}
                content={modelHelper.buildModalSection(this.getUnitOptions())}
                footer={modelHelper.buildModalSection(
                    <React.Fragment>
                        <Button
                            onClick={this.handleSaveClick}
                            svgBefore={imgConfirm}
                            label={<Translate value="general.confirm" />}
                        />
                        <CancelButton onClick={this.handleCloseModalClick} />
                    </React.Fragment>,
                    "flex-gap-10px"
                )}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        manualAdditionUnit: store.settings.manualAdditionUnit,
        shotsName: store.settings.shotsName,
        message: store.rcc.machine.dialog === null ? -1 : store.rcc.machine.dialog.message
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.MANUAL_ADDITION_UNIT_MODAL));
        },
        dispatchSetManualColorantAdditionUnitAction: (unit) => {
            dispatch(rccActions.setManualColorantAdditionUnit(unit));
        }
    };
};

export default ManualAdditionUnitModal = connect(mapStoreToProps, mapDispatchToProps)(ManualAdditionUnitModal);
